import { useFunnelContext } from "shared/Funnel/FunnelContextProvider";
import { useI18n } from "utils/with-i18n.utils";

import Calendar from "./calendar.svg";
import DeviceSync from "./device-sync.svg";
import Medal from "./medal.svg";
import Security from "./security.svg";
import Truck from "./truck.svg";
import YellowStarSVG from "./yellow-star.svg";

export const ProductConditions = () => {
  const i18n = useI18n();
  const { isSwap } = useFunnelContext();

  const commonIconTranslationKeyList = [
    {
      icon: <Security />,
      translationKey: "product.conditions.insurances",
    },
    {
      icon: <Truck />,
      translationKey: "product.conditions.freePickupStore",
    },
    {
      icon: <Medal />,
      translationKey: "product.conditions.insured",
    },
  ];

  const iconTranslationKeyList = isSwap
    ? commonIconTranslationKeyList
    : [
      {
        icon: <Calendar />,
        translationKey: "product.conditions.trial",
      },
      ...commonIconTranslationKeyList,
    ];

  return (
    <section className="relative w-full max-w-md leading-5 bg-white rounded-md border-2 border-black">
      <ul className={"flex flex-col gap-3 p-4"}>
        {iconTranslationKeyList.map(({ icon, translationKey }) => (
          <li className="flex gap-4 items-center" key={translationKey}>
            {icon}
            {i18n.t(translationKey, {}, { html: true })}
          </li>
        ))}
      </ul>


      <div className="flex gap-4 items-center py-3 px-4 text-white bg-gradient-to-l from-blue-conditions to-pink-conditions">
        <DeviceSync />
        {i18n.t("product.conditions.freeSwap", {}, { html: true })}
      </div>
      <YellowStarSVG className="absolute -top-3 left-60 2xs:left-72" />
      <YellowStarSVG className="absolute top-3/4 -left-3 -translate-y-5" />
      <YellowStarSVG className="absolute -bottom-3 left-48 2xs:left-52" />
    </section>
  );
};
